import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "@/components/ui/notify";
import { isApiClientError } from "@/lib/api-client";
import { useCreateScenario } from "@/features/simulations/hooks";
import { useSandboxDraft } from "./useSandboxDraft";

// Cria um cenário a partir de uma linha e abre o sandbox. O cenário nasce
// vazio de structureSnap; o sandbox hidrata da linha na abertura.
export function useStartSandbox() {
  const navigate = useNavigate();
  const create = useCreateScenario();

  return useCallback(
    async (lineId: string, lineName: string) => {
      try {
        useSandboxDraft.getState().reset();
        const created = await create.mutateAsync({
          lineId,
          base: "CURRENT_LINE",
          name: `E se… ${lineName}`,
        });
        navigate(`/simulations/sandbox/${created.id}`);
      } catch (err) {
        const msg = isApiClientError(err) ? err.error.message : "Erro inesperado.";
        toast.error("Não foi possível abrir o sandbox.", { description: msg });
      }
    },
    [create, navigate]
  );
}

// Cria um cenário "linha nova" (sem lineId) e abre o sandbox com canvas vazio.
export function useStartNewLineSandbox() {
  const navigate = useNavigate();
  const create = useCreateScenario();

  return useCallback(async () => {
    try {
      useSandboxDraft.getState().reset();
      const created = await create.mutateAsync({ base: "CURRENT_LINE", name: "Linha nova" });
      navigate(`/simulations/sandbox/${created.id}`);
    } catch (err) {
      const msg = isApiClientError(err) ? err.error.message : "Erro inesperado.";
      toast.error("Não foi possível criar a linha nova.", { description: msg });
    }
  }, [create, navigate]);
}
